import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Calculator } from "@/components/Calculator";
import { WhyChoose } from "@/components/WhyChoose";
import { Testimonials } from "@/components/Testimonials";
import { DemoHighlight } from "@/components/DemoHighlight";
import { Faq } from "@/components/Faq";
import { FinalCta } from "@/components/FinalCta";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { ChatWidget } from "@/components/ChatWidget";
import DemoCardapio from "@/pages/DemoCardapio";
import OwnerChat from "@/pages/OwnerChat";

const Landing = () => {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, anchors: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="min-h-screen overflow-x-clip bg-[#07090E] font-sans text-slate-100 antialiased">
            <div className="noise-overlay" aria-hidden="true" />
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <Services />
                <DemoHighlight />
                <Calculator />
                <WhyChoose />
                <Testimonials />
                <Faq />
                <FinalCta />
            </main>
            <Footer />
            <FloatingWhatsApp />
            <ChatWidget />
        </div>
    );
};

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/demo" element={<DemoCardapio />} />
                <Route path="/atendimento" element={<OwnerChat />} />
            </Routes>
        </BrowserRouter>
    );
}
